// ------------------------------------------------------------------
// PURE MODULE: svgwvs.mod.js
// ------------------------------------------------------------------
import gsap from "gsap";

export function createWaveAnimation(circles, timeline, scaleFactor) {
    // Safety checks
    if (!circles) return timeline;
    if (circles.length < 3) return timeline;

    // Logic
    const scales = [2 / scaleFactor, 1.5 / scaleFactor, 1.33 / scaleFactor];
    const opacities = [1, 0.5, 0];

    gsap.set(circles, { transformOrigin: 'center' });
    gsap.set(circles[0], { opacity: 0 });
    gsap.set(circles[1], { opacity: 1 });
    gsap.set(circles[2], { opacity: 0.5 });

    circles.forEach((circle, i) => {
        // Animate all circles at the same time (position '0')
        timeline.to(circle, { scale: scales[i], opacity: opacities[i] }, 0);
    });

    return timeline;
}